module.exports = __webpack_public_path__ + "static/media/desktop.0a839ae9.ico";